import { qrConstants } from "../constants";
import { qrRequests } from "../../services";
import { handleErrorMessage } from "../../utils";

export const qrActions = {}

qrActions.GetQrUid = (data) => {
    return dispatch => {
        dispatch(request())
        qrRequests.GetQrUid(data)
            .then(
                qruid => dispatch(success(qruid)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: qrConstants.QR_UID_REQUEST }
    }
    function success(qruid) {
        return { type: qrConstants.QR_UID_SUCCESS, qruid }
    }
    function failure(error) {
        return { type: qrConstants.QR_UID_FAILURE, error }
    }
}

qrActions.GetQrUidData = (data) => {
    return dispatch => {
        dispatch(request())
        qrRequests.GetQrUidData(data)
            .then(
                qruidData => dispatch(success(qruidData)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: qrConstants.QR_DATA_REQUEST }
    }
    function success(qruidData) {
        return { type: qrConstants.QR_DATA_SUCCESS, qruidData }
    }
    function failure(error) {
        return { type: qrConstants.QR_DATA_FAILURE, error }
    }
}

qrActions.GetAssociatedFile = (data) => {
    return dispatch => {
        dispatch(request())
        qrRequests.GetAssociatedFile(data)
            .then(
                qrFile => dispatch(success(qrFile)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: qrConstants.QR_FILE_REQUEST }
    }
    function success(qrFile) {
        return { type: qrConstants.QR_FILE_SUCCESS, qrFile }
    }
    function failure(error) {
        return { type: qrConstants.QR_FILE_FAILURE, error }
    }
}

